import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Layout/ShowMoreNewsWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Navbar/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/Posts/PostDetails/MoreNews.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/components/tag/Category.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/rastra-bharat-new/src/app/lib/SchemaScript.js");
